import * as React from 'react';
import { Box } from '@drone-js/core';
import { ULTheme } from '@theme/types';
import styled, { withTheme } from 'styled-components';
import { usePageBackground } from '@v2/pages/hooks/usePageBackground';

const DimBackdrop = styled(Box)`
    background-image: linear-gradient(180deg, transparent 70%, rgba(42, 42, 58, 0.5));
`;

// Adds background with/without backdrop
export const AgojiBackground: React.FC<{
    children: React.ReactNode;
    theme?: ULTheme;
    showBackgroundImage?: boolean;
    useDimBottom?: boolean;
}> = withTheme(props => {
    const StyledBox = styled(Box)({
        backgroundImage: props.showBackgroundImage ? `${props.theme.background.image}` : undefined,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: props.theme.background.position,
        backgroundSize: props.theme.background.size,
    });

    const { backgroundColor } = usePageBackground();

    const PageBackgroundWrapper = props.showBackgroundImage ? StyledBox : Box;

    return (
        <PageBackgroundWrapper backgroundColor={backgroundColor} minHeight="100vh" minWidth="100vw" data-cy="app-bg">
            {
                // tslint:disable-next-line: jsx-no-multiline-js
                props.showBackgroundImage && props.useDimBottom ? (
                    <DimBackdrop minHeight="inherit" data-cy="app-bg-backdrop">
                        {props.children}
                    </DimBackdrop>
                ) : (
                    props.children
                )
            }
        </PageBackgroundWrapper>
    );
});

AgojiBackground.displayName = 'AgojiBackground';
